<template>
  <div class="" v-if="$parent.active==name">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props:{
    label:{
      type: String,
      default: ""
    },
    name:{
      type: String,
      default: ""
    },
    active:{
      type:String
    }
  },
  data(){
    return{}
  }
  
  
}
</script>